import { IRequirementDefinitionCreateRequest } from "@wingspanhq/payments/dist/interfaces";

import {
  convertFormApprovalDataToReviewStrategy,
  convertFormDataToExpirationStrategy
} from "../components/CreateRequirementDefinitionForm/utils";
import { BaseRequirementDefinitionFormValues } from "../types";

export const baseMapFormDataToRequirementCreateRequest = (
  formData: BaseRequirementDefinitionFormValues
): Omit<
  IRequirementDefinitionCreateRequest,
  "dataSourceId" | "dataSourceType" | "clientId"
> => {
  return {
    description: formData.description,
    name: formData.name,
    requirementType: formData.type,
    reviewStrategy: convertFormApprovalDataToReviewStrategy(formData),
    ...convertFormDataToExpirationStrategy(formData)
  };
};
